import { Phone } from 'lucide-react';
import { siteInfo } from '../../data/mock';

export const HeroIdentity = () => (
<>
<div className="mb-8">
              <span className="inline-block bg-red-600/20 border border-red-600/40 text-red-400 px-6 py-2 rounded-full text-sm font-semibold mb-4 backdrop-blur-sm">
                ✨ Plus Grand Marabout de Guadeloupe
              </span>
            </div>
            
            <h1 data-testid="home-practitioner-name" className="text-4xl md:text-6xl lg:text-7xl font-bold mb-3 text-white leading-tight">
              Maître Diamma
              <span className="sr-only"> — Marabout africain en Guadeloupe</span>
            </h1>
            <a
              data-testid="hero-phone-link"
              href={`tel:${siteInfo.phone}`}
              aria-label={`Appeler Maître Diamma au ${siteInfo.phoneDisplay}`}
              className="inline-flex max-w-full items-center justify-center gap-2 py-2 mb-5 text-2xl md:text-3xl font-bold text-yellow-400 hover:text-yellow-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-yellow-400 transition-colors"
            >
              <Phone aria-hidden="true" className="w-6 h-6 md:w-7 md:h-7 flex-shrink-0" />
              <span>{siteInfo.phoneDisplay}</span>
            </a>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 text-red-600 leading-tight">
              Marabout Africain • Sorcier Vaudou Haïtien
            </h2>
            <p className="text-xl md:text-2xl lg:text-3xl mb-8 text-white font-semibold">
              Spécialiste du Retour Affectif Rapide en Guadeloupe
            </p>
</>
);
